<template src="./company-campaigns.html"></template>
<script>
import mixins from "../../../../mixins/mixins.js";
export default {
  mixins: [mixins],
  data() {
    return {
      campaigns: [],
      campaignsPaginated: [],
      idCompany: null,
      currentx: 1,
      numPages: 0,
      windowWidth: 0,
      pagination: false,
    };
  },
  watch: {
    currentx: function () {
      const vm = this;
      vm.changePagination();
    },
  },
  created() {
    const vm = this;
    window.addEventListener("resize", vm.handleResize);
    vm.handleResize();
  },
  destroyed() {
    const vm = this;
    window.removeEventListener("resize", vm.handleResize);
  },
  mounted: function() {
    var vm = this;
    vm.init();
  },
  methods: {
    init() {
      var vm = this;
      if (vm.testNullUndefinedEmpty(vm.$session.get("idCompany")) === false) {
        vm.idCompany = vm.$session.get("idCompany");
        vm.getCampaigns();
      }
    },
    getCampaigns() {
      var vm = this;
      this.axios
        .get(
          vm.$store.state.filooServer + "campaign/find_by_companyid/" + vm.idCompany,
          {
            headers: { Authorization: vm.$session.get("bearer") },
          }
        )
        .then(function(response) {
          if(response.status === 200){
            vm.campaigns = response.data;
            vm.numPages = Math.ceil(vm.campaigns.length / 10);
            vm.pagination = vm.numPages > 1;
            for(const c in vm.campaigns){
              vm.campaigns[c].statusText = vm.campaigns[c].status === true? "Ativa" : "Inativa";
            }
          }
          vm.changePagination();
        }).catch(function(error) {
          console.log({ error_getCampaigns: error });
        });
    },
    changePagination() {
      const vm = this;
      const campaigns = vm.campaigns;
      if (vm.currentx === 1) {
        vm.campaignsPaginated = campaigns.slice(0, 10);
      } else {
        vm.campaignsPaginated = campaigns.slice(
          (vm.currentx - 1) * 10,
          vm.currentx * 10
        );
      }
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    handleResize() {
      const vm = this;
      vm.windowWidth = window.innerWidth;
    },
  },
};
</script>

<style lang="scss" src="./company-campaigns.scss">
</style>
